<template>
    <div>
        <div v-if="!saveSuccess">
            <div ref="alertAnchor" class="anchor"></div>
            <Alert :alert="alert" />
            <p>
                Importante: este espaço é exclusivo para denunciar um produto. Em caso de problemas
                com alguma compra já realizada, fale com a gente
                <a :href="`${$scope.URL_STORE_PREFIX}/fale-conosco`" class="text-underline"
                    >clicando aqui</a
                >.
            </p>

            <p class="mt-4">Você acredita que o anúncio seja:</p>

            <div class="form-group mt-2">
                <SelectField v-model="form.complaint_id" :error.sync="errors.initiative">
                    <option :value="null">Nenhum</option>
                    <option v-for="value in complaintsTypes" :value="value.id">
                        {{ value.complaint }}
                    </option>
                </SelectField>
            </div>

            <div class="form-group mt-3" v-show="form.complaint_id">
                <label :for="form.complaint_id === 1 ? 'comentario' : 'comentario'">
                    {{
                        form.complaint_id !== 1 && form.complaint_id !== 2
                            ? 'Conte mais sobre a sua denúncia:'
                            : form.complaint_id === 1
                            ? 'Indique o direito autoral infringido pelo produto vendido para a avaliação de nossa equipe:'
                            : 'Indique o detentor da imagem autoral e um link com a imagem original para a avaliação de nossa equipe:'
                    }}
                    <span class="obrigatorio" title="Esse campo é obrigatório">*</span>
                    <span class="error" :error.sync="errors.complaint"></span>
                </label>
                <textarea
                    v-model="form.complaint"
                    id="complaint"
                    placeholder="Dê mais detalhes..."
                    rows="4"
                    cols="50"
                    required
                >
                </textarea>
            </div>
        </div>
        <div v-else>
            <Alert :alert="alert" />
        </div>
        <input type="hidden" name="hash" value="" class="dominio" />
        <div class="text-right mt">
            <button
                v-if="!saveSuccess"
                :disabled="submitting"
                class="btn btn-lg btn-image ml-auto"
                @click="submit"
            >
                <span v-if="submitting" class="cr-spinner-small"></span>
                <span v-else>Enviar</span>
            </button>
            <button v-else class="btn btn-lg btn-image ml-auto" @click="close()">
                <span>Fechar</span>
            </button>
        </div>
    </div>
</template>

<script>
    import { complaintsService } from '../../../submodules/src/service/resource';
    import SelectField from '../../../submodules/src/components/input/select-field/SelectField.vue';
    import Alert from '../../../submodules/src/componentsV2/surface/alert/Alert.vue';

    export default {
        name: 'ProductComplain',
        props: {
            product_id: {
                type: Number,
                required: true,
            },
        },

        components: {
            SelectField,
            Alert,
        },

        data() {
            return {
                form: {
                    complaint_id: null,
                    complaint: null,
                    product_id: null,
                },
                errors: {
                    complaint_id: null,
                    complaint: null,
                },
                complaintsTypes: null,
                alert: null,
                submitting: false,
                saveSuccess: false,
                apiErrors: null,
            };
        },

        created() {
            this.fetchDbGetComplaints();
        },
        watch: {
            product_id: {
                immediate: true,
                handler(to) {
                    this.form.product_id = to;
                },
            },
        },
        methods: {
            showError(message) {
                this.alert = {
                    message,
                    isError: true,
                };
            },

            showSuccess(message) {
                this.alert = {
                    message,
                    isError: false,
                    timeout: 0,
                };
            },

            submit() {
                if (!this.form.complaint_id) {
                    this.showError('Por favor, selecione o motivo da denúncia');
                } else if (!this.form.complaint) {
                    this.showError('Por favor, descreva o motivo da denúncia');
                } else {
                    this.submitting = true;
                    complaintsService
                        .sendComplaint(this.form)
                        .then(() => {
                            this.saveSuccess = true;
                            this.showSuccess(
                                'Denúncia recebida, nossa equipe irá analisar o caso relatado e tomar as medidas necessárias, caso apropriado. Agradecemos sua colaboração!'
                            );
                        })
                        .catch(() => {
                            this.submitting = false;
                            this.showError('Não foi possível enviar seus dados');
                        })
                        .then(() => {
                            this.submitting = false;
                        });
                }
            },

            fetchDbGetComplaints() {
                complaintsService
                    .getTypesComplaints()
                    .then((result) => {
                        this.complaintsTypes = result.data.data;
                    })
                    .catch(() => {});
            },

            close() {
                document.location.reload(true);
            },
        },
    };
</script>
